<template>
    <!-- Experian's identity questions, shared by /rentrisk-verification, the
         PMC company registration (RAC-10417) and the self report (86bcfa7n0). -->
    <div class="bg-rent-risk-blue-100 overflow-hidden sm:rounded-lg">
        <div class="relative max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <h4 class="text-3xl text-center font-bold leading-7 text-gray-700 sm:text-2xl sm:truncate">
                Questions
            </h4>
            <div class="grid grid-cols-2 gap-2">
                <div>
                    <form @submit.prevent="store" class="space-y-8 divide-y divide-gray-200">
                        <input type="hidden" id="user_prefs" name="user_prefs"> <input type="hidden" id="user_prefs2" name="user_prefs2">
                        <div class="space-y-8 divide-y divide-gray-200">
                            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div v-for="(question, index) in questions" :key="index" class="sm:col-span-6">
                                    <p class="leading-5">{{ (index+1)+'. '+question.questionText }}</p>
                                    <fieldset class="mt-4 ml-4">
                                        <div class="space-y-4">
                                            <div v-for="(option, choiceId) in question.questionSelect.questionChoice" :key="'question'+index+'-'+(choiceId+1)" class="flex items-center">
                                                <input :id="'question'+index+'-'+(choiceId+1)" :name="'question'+(index+1)" v-bind:value="(choiceId+1)" v-on:click="updateAnswer(index, (choiceId+1))" type="radio" class="focus:ring-rent-risk-blue-400 h-4 w-4 text-rent-risk-blue-400 border-gray-300" />
                                                <label :for="'question'+index+'-'+(choiceId+1)" class="ml-3 block text-sm font-medium text-gray-700">
                                                    {{ option }}
                                                </label>
                                            </div>
                                            <p v-if="index === 0" v-text="form.errors.question1" class="text-red-500 text-sm"></p>
                                            <p v-if="index === 1" v-text="form.errors.question2" class="text-red-500 text-sm"></p>
                                            <p v-if="index === 2" v-text="form.errors.question3" class="text-red-500 text-sm"></p>
                                            <p v-if="index === 3" v-text="form.errors.question4" class="text-red-500 text-sm"></p>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                        <div class="pt-5 grid grid-cols-6 gap-4">
                            <div class="col-end-7 col-span-2 justify-end flex">
                                <inertia-link :href="cancelHref" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                                <form-button :form="form" type="submit">
                                    Save
                                </form-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormButton from '@/Shared/FormButton.vue'

export default {
    components: {
        FormButton,
    },
    props: {
        questions: Object,
        // RAC-10417: the PMC company registration reuses this page but posts to
        // its own endpoint. Defaults to the individual verification flow.
        submitRoute: {
            type: String,
            default: 'experian-verification.questions.submit',
        },
        // 86bcfa7n0: the self report runs these questions inside its own steps.
        submitParams: {
            type: [Number, String, Array, Object],
            default: undefined,
        },
        cancelHref: {
            type: String,
            default: () => route('experian-verification.create'),
        },
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                // Neither renderer passes these in — ExperianVerificationController
                // and PmcRegistrationController both send only `questions` (+
                // `submitRoute`). They start empty and updateAnswer() fills them
                // as the user answers, so `this.questionN` was always undefined.
                question1: null,
                question2: null,
                question3: null,
                question4: null,
                user_prefs: null,
                user_prefs2: null,
            })
        }
    },
    methods: {
        store() {
            this.form.user_prefs = adx.validate('user_prefs');
            this.form.user_prefs2 = adx.validate('user_prefs2');
            this.form.post(this.route(this.submitRoute, this.submitParams))
        },
        updateAnswer(question, answer) {
            if((question+1) === 1) {
                this.form.question1 = answer
            }
            else if((question+1) === 2) {
                this.form.question2 = answer
            }
            else if((question+1) === 3) {
                this.form.question3 = answer
            }
            else if((question+1) === 4) {
                this.form.question4 = answer
            }
        },
    }
}
</script>
